import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import './styles.scss';
import useTranslate from 'hooks/useTranslate';
import useResumeStore from 'store/resume';

const CustomProgressBar: React.FC = () => {
	const resumeData = useResumeStore((state) => state?.resumeData);
	const templateFormOptions = resumeData?.templateFormOptions;
	const { translate } = useTranslate();
	const [progress, setProgress] = useState(0);
	const [show, setShow] = useState(false);

	useEffect(() => {
		const calculateProgress = (): number => {
			let filledFields = 0;
			let totalFields = 0;

			const checkObjectHasValues = (obj: any): boolean => {
				for (const key in obj) {
					if (typeof obj[key] === 'object') {
						if (Array.isArray(obj[key])) {
							for (const arrayObj of obj[key]) {
								if (!checkObjectHasValues(arrayObj)) {
									return false;
								}
							}
						} else {
							if (!checkObjectHasValues(obj[key])) {
								return false;
							}
						}
					} else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
						return false;
					}
				}
				return true;
			};

			const isEmptyObject = (obj: object) => {
				return obj && Object.keys(obj).length === 0;
			};

			const countFields = (data: any): void => {
				if (!data || typeof data !== 'object') {
					console.error('Invalid data provided');
					return;
				}

				const processField = (key: string, value: any): void => {
					if (templateFormOptions && templateFormOptions[key]) {
						totalFields++;
						if (typeof value === 'object') {
							if (Array.isArray(value)) {
								if (value.length > 1 || (value.length === 1 && checkObjectHasValues(value[0]))) {
									filledFields++;
								}
							} else if (checkObjectHasValues(value) && !isEmptyObject(value)) {
								filledFields++;
							}
						} else if (value) {
							filledFields++;
						}
					}
				};

				for (const key in data) {
					if (Object.prototype.hasOwnProperty.call(data, key)) {
						processField(key, data[key]);
					}
				}
			};

			countFields(resumeData);

			return totalFields === 0 ? 100 : Math.floor((filledFields / totalFields) * 100);
		};

		setProgress(calculateProgress());
	}, [resumeData, templateFormOptions]);

	useEffect(() => {
		setTimeout(() => {
			setShow(true);
		}, 1500);
	}, [progress]);

	return (
		<div
			className="build-resume-progress"
			style={{
				opacity: show ? 1 : 0,
			}}
		>
			<h6>{`${progress}% ${translate('Resume.complete')}`}</h6>
			<ProgressBar variant="" visuallyHidden now={progress} min={0} max={100} />
		</div>
	);
};

export default CustomProgressBar;
